// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import LoadingBar from 'react-redux-loading-bar'
import { Switch, Route } from 'react-router-dom'
import Waypoint from 'react-waypoint'
import DocumentMeta from 'react-document-meta'

// Internal Dependencies:
import PageData from 'containers/PageData'
import PageEvents from 'containers/PageEvents'
import PageEventsTransition from 'containers/PageEventsTransition'

// import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import HeaderPrimary from 'components/HeaderPrimary/HeaderPrimary'
import HeaderMobilePrimary from 'components/HeaderPrimary/HeaderMobilePrimary'
import Menu from 'components/Menu/Menu'
import PageHeader from 'components/PageHeader/PageHeader'
import Footer from 'components/Footer/Footer'
import PasswordProtected from 'components/PageSections/_PasswordProtected'
import LocationsMap from 'components/LocationsMap/LocationsMap'
import Flag from 'components/Flag/Flag'
import Honours from 'components/Honours/Honours'
import CurriculumNav from 'components/CurriculumNav/CurriculumNav'
import SearchResults from 'components/Search/SearchResults'
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'
import { get } from 'utilities/objects'

class SiteLayout extends React.Component {
	constructor() {
		super()

		this.state = {
			prevPage: false
		}
	}

	// componentWillReceiveProps( nextProps ) {
	// 	const { page } = this.props
	// 	const nextSlug = nextProps.page ? nextProps.page.slug : ''

	// 	if ( page.slug != nextSlug ) {
	// 		this.setState( {
	// 			prevPage: page
	// 		} )
	// 	}
	// }

	componentDidUpdate( prevProps, prevState ) {
		const { page } = this.props
		const { prevPageSlug } = this.state
		const prevSlug = prevProps.page ? prevProps.page.slug : ''

		if ( page.slug != prevSlug && ( ! prevPageSlug || page.slug != prevState.prevPageSlug ) ) {
			// setTimeout( () => {
				this.setState( {
					prevPage: page,
					prevPageSlug: page.slug
				} )
			// }, 1000 )
		}
	}

	showPageHeaderState = ( page ) => {
		if ( ! page ) {
			return false
		}

		const { slug } = page
		const { location } = this.props
		const isHome = '/' == location.pathname
		const template = page && page.template

		if ( isHome ) {
			return false
		}

		if (
			// 'join' == template ||
			'explore' == template ||
			// 'full_width' == template ||
			'flag' == template
		) {
			return false
		}

		return true
	}

	showLoadingState = () => {
		const { location, hasCorrectPageData, page } = this.props
		const { prevPage } = this.state
		const isHome = 'home' == prevPage.slug
		const template = prevPage && prevPage.template

		if ( hasCorrectPageData ) {
			return false
		}

		if ( ! prevPage ) {
			return false
		}

		if ( isHome ) {
			return true
		}

		if (
			// 'join' == template ||
			'explore' == template ||
			// 'full_width' == template ||
			'flag' == template
		) {
			return true
		}

		return false
	}

	render() {
		const { isMobile, isIos, page, selectedArchive, type, location, match, hasCorrectPageData, searchIsOpen, searchResults } = this.props
		let { prevPage } = this.state
		const isHome = '/' == location.pathname
		const template = ! isHome ? page && page.template : false
		let className = isHome ? 'site-wrap is-home' : 'site-wrap'
		let showFooter = true
		let contentHasLoaded = !! page
		let showPageHeader = this.showPageHeaderState( page )
		let showBlankLoading = this.showLoadingState()
		// let showBlankLoading = false

		// if ( ! hasCorrectPageData ) {
		// 	let showPageHeaderPrev = this.showPageHeaderState( prevPage )

		// 	if ( ! showPageHeaderPrev ) {
		// 		showBlankLoading = true
		// 	}
		// }

		if ( isIos ) {
			className += ' is-ios'
		}

		if ( isHome ) {
			// showPageHeader = false
			showFooter = false
			document.documentElement.classList.add( 'is-home' )
		} else {
			document.documentElement.classList.remove( 'is-home' )
		}

		if ( template ) {
			className += ` page-${template}`
		}

		if ( page && page.slug ) {
			className += ` page-${page.slug}`
		}

		if ( page && page.content_type ) {
			if ( match.params.slug ) {
				className += ` content-type-${page.content_type}`
			}
		}

		if ( page && page.content_section ) {
			if ( match.params.slug ) {
				className += ` content-section-${page.content_section}`
			}
		}

		if ( page.is_password_protected ) {
			showFooter = false
			className += ' is-password-protected'
		}

		if ( ! contentHasLoaded ) {
			showFooter = false
		}

		// Search:
		let showSearchResults = false

		if ( searchIsOpen ) {
			className += ' with-search-open'
		}

		if ( searchIsOpen && searchResults && searchResults.has_results ) {
			showSearchResults = true
			className += ' with-search-results-open'
		}

		// Set head data:
		let documentMeta = false

		if ( page && page.url ) {
			let relativeUrl = page.url

			if ( relativeUrl.charAt( 0 ) === '/' ) {
				relativeUrl = relativeUrl.slice( 1 )
			}

			document.querySelector('title').innerHTML = `${page.title.raw} — ${siteData.site_name}`
			documentMeta = {
				description: page.description,
				canonical: `${siteData.site_url}/${relativeUrl}`,
				meta: {
					'og:url': `${siteData.site_url}/${relativeUrl}`,
					'og:title': page.title.raw,
					'og:description': page.description
				}
			}
		} else if ( selectedArchive && selectedArchive.url ) {
			let relativeUrl = selectedArchive.url

			if ( relativeUrl.charAt( 0 ) === '/' ) {
				relativeUrl = relativeUrl.slice( 1 )
			}

			document.querySelector('title').innerHTML =`${selectedArchive.title.raw} — ${siteData.site_name}`
			documentMeta = {
				description: selectedArchive.description,
				canonical: `${siteData.site_url}/${relativeUrl}`,
				meta: {
					'og:url': `${siteData.site_url}/${relativeUrl}`,
					'og:title': selectedArchive.title.raw,
					'og:description': selectedArchive.description
				}
			}
		} else {
			document.querySelector('title').innerHTML = siteData.site_name
			documentMeta = {
				description: '',
				canonical: siteData.site_url,
				meta: {
					'og:url': siteData.site_url,
					'og:title': siteData.site_name,
					'og:description': ''
				}
			}
		}

		return (
			<div className={ className }>
				{ documentMeta &&
					<DocumentMeta { ...documentMeta } />
				}

				<PageData { ...this.props } />
				<PageEvents />
				{/*<PageEventsTransition { ...this.props } />*/}

				<div className="site">
					{/*<div className="loading">
						<LoadingSpinner />
					</div>*/}

					<HeaderMobilePrimary />

					<div className="main-wrap">
						<LoadingBar className="header-loading-bar" updateTime={ 100 } maxProgress={ 90 } progressIncrease={ 10 } />

						<HeaderPrimary match={ match } />

						{ showBlankLoading &&
							<section className="main">
								<div className="main-inner without-page-header">
									{/* showPageHeader &&
										<PageHeader key="page-header" pathname={ location.pathname } />
									*/}

									{/* showPageHeader &&
										<div className="page-sections-wrap"></div>
									*/}
								</div>
							</section>
						|| showSearchResults &&
							<ErrorBoundary>
								<SearchResults />
							</ErrorBoundary>
						|| 'join' == template &&
							<section className="main">
								{ showPageHeader &&
									<PageHeader key="page-header" pathname={ location.pathname } styleType="wide" />
								}

								<div className="main-inner without-page-header">
									{ this.props.children }

									<LocationsMap />
								</div>
							</section>
						|| 'explore' == template &&
							<section className="main">
								<div className="main-inner without-page-header">
									{ this.props.children }
								</div>
							</section>
						|| 'flag' == template &&
							<section className="main">
								<div className="main-inner without-page-header">
									<Flag />
								</div>
							</section>
						|| 'curriculum' == template &&
							<section className="main">
								<div className="main-inner without-page-header">
									<CurriculumNav />
								</div>
							</section>
						|| 'full_width' == template &&
							<section className="main is-wide">
								{ showPageHeader &&
									<PageHeader key="page-header" pathname={ location.pathname } styleType="wide" />
								}

								<div className="main-inner without-page-header">
									{ this.props.children }
								</div>
							</section>
						|| 'honours' == template &&
							<section className="main">
								<div className="main-inner">
									{ showPageHeader &&
										<PageHeader key="page-header" pathname={ location.pathname } type="honours" slug={ location.pathname.replace( /\//g, '' ) } />
									}

									{/*<Honours { ...this.props } />*/}
									{ this.props.children }
								</div>
							</section>
						|| 'activities' == template &&
							<section className="main">
								<div className="main-inner">
									{ showPageHeader &&
										<PageHeader key="page-header" pathname={ location.pathname } type="activities" slug={ location.pathname.replace( /\//g, '' ) } />
									}

									{ this.props.children }
								</div>
							</section>
						||
							<section className="main is-narrow">
								<div className="main-inner">
									{ showPageHeader &&
										<PageHeader key="page-header" pathname={ location.pathname } type={ type } />
									}

									{ this.props.children }
								</div>
							</section>
						}
					</div>
				</div>

				{ showFooter &&
					<Footer />
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	const { selected, selectedArchive } = state.page
	const isHome = '/' == location.pathname

	let page = false,
		hasCorrectPageData

	if ( ownProps.pageOverride ) {
		page = ownProps.pageOverride
	} else if ( selectedArchive ) {
		page = selectedArchive
	} else {
		page = selected
	}

	if ( isHome ) {
		hasCorrectPageData = true
	} else if ( selectedArchive ) {
		hasCorrectPageData = ( selectedArchive && ownProps.type == selectedArchive.type )
	} else {
		const slug = get( [ 'match', 'params', 'slug' ] )( ownProps )

		hasCorrectPageData = ( selected && slug == selected.slug )
	}

	return {
		isMobile: state.site.isMobile,
		isIos: state.site.isIos,
		// page: state.page.selected,
		page,
		selectedArchive: state.page.selectedArchive,
		hasCorrectPageData,
		searchIsOpen: state.search.isOpen,
		searchResults: state.search.searchResults
	}
}

export default connect( mapStateToProps )( SiteLayout )



// WEBPACK FOOTER //
// ./views/layouts/SiteLayout.jsx